const CHUNK_RELOAD_SESSION_KEY = 'app-chunk-reload';
const CHUNK_RELOAD_QUERY_PARAM = '_app_reload';

// Includes Vite/webpack dynamic-import failures and browsers rejecting
// index.html (SPA fallback) served for a missing hashed JS asset.
const CHUNK_LOAD_ERROR_PATTERN =
  /Failed to fetch dynamically imported module|Loading chunk .* failed|Importing a module script failed|error loading dynamically imported module|is not a valid JavaScript MIME type|Expected a JavaScript(?:-or-Wasm)? module script but the server responded with a MIME type of ["']text\/html["']|disallowed MIME type \([^)]*text\/html[^)]*\)/i;

export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error ? error.message : String(error ?? '');

  return CHUNK_LOAD_ERROR_PATTERN.test(message);
}

export function clearChunkReloadFlag(): void {
  sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);

  const url = new URL(window.location.href);

  if (!url.searchParams.has(CHUNK_RELOAD_QUERY_PARAM)) {
    return;
  }

  url.searchParams.delete(CHUNK_RELOAD_QUERY_PARAM);
  window.history.replaceState(
    window.history.state,
    '',
    `${url.pathname}${url.search}${url.hash}`,
  );
}

export function reloadAppOnce(): boolean {
  if (sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY)) {
    return false;
  }

  sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, '1');

  const url = new URL(window.location.href);
  url.searchParams.set(CHUNK_RELOAD_QUERY_PARAM, Date.now().toString());
  window.location.replace(url.toString());

  return true;
}
